import React from 'react';
import PropTypes, { any } from 'prop-types';

import Filter, { FilterModal, FilterSection } from './Filter';
import NumericInput from './FilterComponents/CoreComponents/NumericInput';

import styles from '../search.scss';

const AgeInputFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'age'}
                handleFilterClick={handleFilterClick}
                isActive={filters?.age || filterModal === 'age'}
                onClick={() => {
                    handleFilterClick('age');
                }}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Age{filters?.age ? `: ${filters?.age}` : ''}
            </Filter>
            {filterModal === 'age' && (
                <FilterModal
                    title={'Age'}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                    handleFilterSubmit={() => {
                        handleFilterSubmit();
                    }}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        Enter your age:
                        <NumericInput
                            value={filterInputs.age || ''}
                            onChange={(age) => {
                                handleFilterUpdate({ age });
                            }}
                            data-testid={dataTestId && `${dataTestId}.age-input`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

AgeInputFilter.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};
AgeInputFilter.defaultProps = {
    handleFilterClick: () => { },
    handleFilterSubmit: () => { },
    closeModals: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': undefined,
};

export default AgeInputFilter;
